import consentManagementModule from './consentManagement';
import priceFloorsModule from './priceFloors';
import {applyPlaceholders} from '../../utils/placeholder';
import storage from '../../utils/storage';

function _getPlaceholders() {
	return {
		'PWID': () => storage.getFromCookie('authId'),
		'domain': window.location.hostname
	};
}

export function getModuleConfig(config) {
	const prebidModuleConfig = JSON.parse(JSON.stringify(config.additionalConfig || {}));

	consentManagementModule.apply(prebidModuleConfig, config);
	priceFloorsModule.apply(prebidModuleConfig, config);

	return applyPlaceholders(prebidModuleConfig, _getPlaceholders());
}

export function getBidderModuleConfigs(config) {
	const additionalBidderConfigs = JSON.parse(JSON.stringify(config.additionalBidderConfigs || []));

	return additionalBidderConfigs.map((bidderConfig) => {
		return applyPlaceholders(bidderConfig, _getPlaceholders());
	});
}

export default {
	getModuleConfig,
	getBidderModuleConfigs
};
